import { IntroSectionData } from "../../../types/IntroSectionData";
import Img0 from '../../../assets/images/itm-3.png';
import Img1 from '../../../assets/images/itm-2.png';
import Img2 from '../../../assets/images/itm-6.png';
import Img3 from '../../../assets/images/itm-4.png';
import Img4 from '../../../assets/images/itm-7.png';

const introSectionData1: IntroSectionData = {
  sectionTitle: "Bénéfices clés",
  sectionTitleKey: "incidentCyber.expertise.sectionTitle",
  sectionSubtitle: "Réponse aux incidents",
  sectionSubtitleKey: "incidentCyber.expertise.sectionSubtitle2",
  translationNamespace: "incidentCyber",
  tabsData: [
    {
      id: 0,
      title: "Résilience",
      titleKey: "incidentCyber.expertise.tabs.investigations.title",
      heading: "Comment assurer une prise de décision lucide et structurée en pleine cyberattaque ?",
      headingKey: "incidentCyber.expertise.tabs.investigations.heading",
      text: "Nous apportons immédiatement une méthodologie et un leadership clairs en gestion de crise, structurant les actions pour vous permettre de reprendre le contrôle de la situation avec sang-froid.",
      textKey: "incidentCyber.expertise.tabs.investigations.text",
      text1: "Comment assurer une prise de décision lucide et structurée en pleine cyberattaque ?",
      text1Key: "incidentCyber.expertise.tabs.investigations.text1",
      text2: "Nous apportons immédiatement une méthodologie et un leadership clairs en gestion de crise, structurant les actions pour vous permettre de reprendre le contrôle de la situation avec sang-froid.",
      text2Key: "incidentCyber.expertise.tabs.investigations.text2",
      key: "investigations"
    },
    {
      id: 1,
      title: "Évaluation",
      titleKey: "incidentCyber.expertise.tabs.eradication.title",
      heading: "Comment identifier rapidement l'ampleur de l'attaque, les données compromises et les systèmes toujours menacés ?",
      headingKey: "incidentCyber.expertise.tabs.eradication.heading",
      text: "Nos compétences d'investigation et d'analyse forensique, nous permet de qualifier précisément l'incident pour vous fournir une vision exacte de l'impact et de la surface de compromission.",
      textKey: "incidentCyber.expertise.tabs.eradication.text",
      text1: "Comment identifier rapidement l'ampleur de l'attaque, les données compromises et les systèmes toujours menacés ?",
      text1Key: "incidentCyber.expertise.tabs.eradication.text1",
      text2: "Nos compétences d'investigation et d'analyse forensique, nous permet de qualifier précisément l'incident pour vous fournir une vision exacte de l'impact et de la surface de compromission.",
      text2Key: "incidentCyber.expertise.tabs.eradication.text2",
      key: "eradication"
    },
    {
      id: 2,
      title: "Remédiation",
      titleKey: "incidentCyber.expertise.tabs.assistance.title",
      heading: "Chaque heure d'interruption génère des pertes concrètes. Comment rétablir vos services rapidement tout en garantissant un haut niveau de sécurité ?",
      headingKey: "incidentCyber.expertise.tabs.assistance.heading",
      text: "Notre priorité est d'accélérer la restauration sécurisée de vos systèmes et la reprise de vos activités, en validant l'intégrité de chaque composant pour minimiser l'impact financier de l'incident.",
      textKey: "incidentCyber.expertise.tabs.assistance.text",
      text1: "Chaque heure d'interruption génère des pertes concrètes. Comment rétablir vos services rapidement tout en garantissant un haut niveau de sécurité ?",
      text1Key: "incidentCyber.expertise.tabs.assistance.text1",
      text2: "Notre priorité est d'accélérer la restauration sécurisée de vos systèmes et la reprise de vos activités, en validant l'intégrité de chaque composant pour minimiser l'impact financier de l'incident.",
      text2Key: "incidentCyber.expertise.tabs.assistance.text2",
      key: "assistance"
    },
    {
      id: 3,
      title: "Éradication",
      titleKey: "incidentCyber.expertise.tabs.postIncident.title",
      heading: "Après une première intervention, comment être absolument certain que la menace a été complètement éradiquée et que l'attaquant n'a pas laissé de portes dérobées pour une future attaque ?",
      headingKey: "incidentCyber.expertise.tabs.postIncident.heading",
      text: "Nous allons au-delà de la simple restauration ; nous éradiquons la cause racine de l'incident, recherchons les indicateurs de compromission persistants et validons l'intégrité de vos systèmes pour garantir une neutralisation complète.",
      textKey: "incidentCyber.expertise.tabs.postIncident.text",
      text1: "Après une première intervention, comment être absolument certain que la menace a été complètement éradiquée et que l'attaquant n'a pas laissé de portes dérobées pour une future attaque ?",
      text1Key: "incidentCyber.expertise.tabs.postIncident.text1",
      text2: "Nous allons au-delà de la simple restauration ; nous éradiquons la cause racine de l'incident, recherchons les indicateurs de compromission persistants et validons l'intégrité de vos systèmes pour garantir une neutralisation complète.",
      text2Key: "incidentCyber.expertise.tabs.postIncident.text2",
      key: "postIncident"
    },
  ],
  fixedImageSrc: Img0,
  fixedImageAlt: "IT Monkeys Cloud Cyber",
  fixedImageAltKey: "incidentCyber.expertise.imageAlt"
};

export default introSectionData1;